import React from 'react';

import ReactDOM from 'react-dom/client';

import './i18n';
import './styles/globals.css';
import App from './App';
import { validateEnv } from './config/env';
import { defaultsHeadersAxios } from './services/apiService';
import { AUTH_TOKEN } from 'utils/constants';
import { getItemStorage } from 'utils/persistenceUtils';

// Validate environment variables before rendering
validateEnv();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const token = getItemStorage(AUTH_TOKEN);

defaultsHeadersAxios(token || '');

root.render(<App />);
